import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import VueResource from 'vue-resource'
Vue.use(VueResource)

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// 动画 4.1.1基础上改动过
import animated from './assets/animate.css';
Vue.use(animated);

import VueTouch from 'vue-touch/dist/vue-touch'
// VueTouch.config.swipe= {
//   irection: 'horizontal'
// }; 
Vue.use(VueTouch, {name: 'v-touch'})

new Vue({
  render: h => h(App),
}).$mount('#app')



